module.exports = __webpack_public_path__ + "static/media/logo-branca-vertical-660.769b9073.png";